<template>
    <tsoft-finance-requests-by-parameters
        :additionalGetParameter="getAdditionalParameter()"
    />
</template>

<script>
import tsoftFinanceRequestsByParameters from '@components/finance/FinanceRequestsByParameters'

import {
    defaultDataItems,
    actionShowItem,
    actionCreateOrUpdateItem,
    actionDeleteItem,
    changeCommasOnDots,
} from '@/mixins'

const initialEditedItem = () => ({
    id: '',
    creator_user_id: '',
    for_user_id: '',
    finance_id: '',
    order_id: '',
    order_service_id: '',
    company_id: '',
    comment: '',
    end_comment: '',
    reference_type_id: '',
    reference_status_id: '',
    type_of_request: '',            // auto field with type of request name
    operation_generation: '',       // auto filed with operation text generation by incoming parameters
    status: '',                     // auto field with status of request name
})

export default {
    components: {tsoftFinanceRequestsByParameters},
    mixins: [
        defaultDataItems,
        actionShowItem,
        actionCreateOrUpdateItem,
        actionDeleteItem,
        changeCommasOnDots,
    ],
    data() {
        return {
            isSideBarOpenCompany: false
        }
    },
    mounted() {
        this.editedItem = initialEditedItem();
    },
    methods: {
        getAdditionalParameter() {
            if (this.$route.params.user_id) {
                if (this.$route.params.user_id === 'agents') {
                    return '&is_agents=true';
                } else {
                    return `&creator_user_id=${this.$route.params.user_id}`;
                }
            }
            return '';
        }
    },
}
</script>
